import AccommodationBookingsPage from '@my-pages/features/object-booking/views/AccommodationBookingsPage';
import StartPage from '@my-pages/features/start/pages/StartPage';
import {
    AccommodationBookingInformationPageContentModelContentType,
    AccommodationBookingObjectContentResponseModelContentType,
    AccommodationBookingsPageContentModelContentType,
    AccommodationLandingPageContentResponseModelContentType,
    CollectiveAgreementPageContentResponseModelContentType,
    ContactPageContentModelContentType,
    CookieInformationPageContentModelContentType,
    CoursePageContentModelContentType,
    EmploymentPageContentModelContentType,
    IApiContentResponseModel,
    LoginPageContentResponseModelContentType,
    MembershipFeePageContentModelContentType,
    MembershipPageContentModelContentType,
    StartPageContentModelContentType,
    TrustedMemberPageContentModelContentType,
    AccommodationBookingGroupPageContentResponseModelContentType,
} from '@shared/integrations/umbraco-taf-delivery-api/models';
import AccommodationBookingsInformationPage from '@my-pages/features/object-booking/views/AccommodationBookingsInformationPage.tsx';
import AccommodationLandingPage from '@my-pages/features/object-booking/views/AccommodationLandingPage';
import TrustedMemberPage from '@my-pages/features/trusted-member/pages/TrustedMemberPage.tsx';
import AccommodationBookingObjectPage from '@my-pages/features/object-booking/views/AccommodationBookingObjectPage.tsx';
import MemberFeePage from '@my-pages/features/member-fee/pages/MemberFeePage';
import MembershipPage from '@my-pages/features/membership/pages/MembershipPage.tsx';
import EmploymentPage from '@my-pages/features/employment/pages/EmploymentPage.tsx';
import CoursesPage from '@my-pages/features/courses/pages/CoursesPage';
import ContractsPage from '@my-pages/features/contracts/pages/ContractsPage.tsx';
import ContactPage from '@my-pages/features/contact/pages/ContactPage.tsx';
import AccommodationBookingGroupPage from '@my-pages/features/object-booking/views/AccommodationBookingGroupPage';
import CookieDeclaration from '@my-pages/features/cookies/views/CookieDeclaration.tsx';
import Login from '@my-pages/features/auth/views/Login';
interface PageContentRendererProps {
    pageData?: IApiContentResponseModel;
}

const PageContentRenderer = ({ pageData }: PageContentRendererProps) => {
    switch (pageData?.contentType) {
        case StartPageContentModelContentType.startPage:
            return <StartPage />;
        case ContactPageContentModelContentType.contactPage:
            return <ContactPage content={pageData} />;
        case CollectiveAgreementPageContentResponseModelContentType.collectiveAgreementPage:
            return <ContractsPage content={pageData} />;
        case CoursePageContentModelContentType.coursePage:
            return <CoursesPage content={pageData} />;
        case EmploymentPageContentModelContentType.employmentPage:
            return <EmploymentPage content={pageData} />;
        case MembershipPageContentModelContentType.membershipPage:
            return <MembershipPage content={pageData} />;
        case MembershipFeePageContentModelContentType.membershipFeePage:
            return <MemberFeePage content={pageData} />;
        case TrustedMemberPageContentModelContentType.trustedMemberPage:
            return <TrustedMemberPage content={pageData} />;
        case AccommodationLandingPageContentResponseModelContentType.accommodationLandingPage:
            return <AccommodationLandingPage content={pageData} />;
        case AccommodationBookingObjectContentResponseModelContentType.accommodationBookingObject:
            return <AccommodationBookingObjectPage content={pageData} />;
        case AccommodationBookingInformationPageContentModelContentType.accommodationBookingInformationPage:
            return <AccommodationBookingsInformationPage content={pageData} />;
        case AccommodationBookingsPageContentModelContentType.accommodationBookingsPage:
            return <AccommodationBookingsPage content={pageData} />;
        case CookieInformationPageContentModelContentType.cookieInformationPage:
            return <CookieDeclaration />;
        case LoginPageContentResponseModelContentType.loginPage:
            return <Login />;
        case AccommodationBookingGroupPageContentResponseModelContentType.accommodationBookingGroupPage:
            return <AccommodationBookingGroupPage content={pageData} />;
        default:
            return 'Nope';
    }
};

export default PageContentRenderer;
